import React, { useState, useEffect } from "react";
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { fetchPodcasts } from "../components/contentfulFiles";
import withScroll from "../components/scroll";
import "../styles/podcasts.css";
import backgroundImage from "../assets/podcast_hero.jpg";

const PODCASTS_PER_PAGE = 5;

const generateSlug = (title) =>
  title.toLowerCase().replace(/[\s_]+/g, "-");

const getYoutubeThumbnail = (url) => {
  const videoId = url.split("v=")[1];
  const end = videoId ? videoId.indexOf("&") : -1;
  return `https://img.youtube.com/vi/${
    end !== -1 ? videoId.substring(0, end) : videoId
  }/0.jpg`;
};

const Podcasts = ({ sectionRef, handleScroll }) => {
  const [podcasts, setPodcasts]       = useState([]);
  const [searchTerm, setSearchTerm]   = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    fetchPodcasts().then(setPodcasts);
  }, []);

  // Sort first, then filter, then paginate
  const sorted = [...podcasts].sort(
    (a, b) => new Date(b.fields.sorttime) - new Date(a.fields.sorttime)
  );

  const filtered = sorted.filter(
    (p) =>
      p.fields.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      p.fields.speaker.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalPages   = Math.ceil(filtered.length / PODCASTS_PER_PAGE);
  const start        = (currentPage - 1) * PODCASTS_PER_PAGE;
  const paginated    = filtered.slice(start, start + PODCASTS_PER_PAGE);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1); // reset to page 1 on new search
  };

  return (
    <div className="podcasts-page">
      <Helmet>
        <title>Podcasts — Calvary First Nigerian SDA Church</title>
      </Helmet>
      <Navbar />
      <main>

        {/* ── Hero ── */}
        <section
          className="podcasts-hero"
          style={{ backgroundImage: `url(${backgroundImage})` }}
        >
          <div className="podcasts-hero-content">
            <h1>Listen to our latest podcasts</h1>
          </div>
          <div className="podcasts-hero-buttons">
            <button className="podcasts-btn" onClick={handleScroll}>
              Listen Now
            </button>
            <Link
              to="https://www.youtube.com/@Cfnsda"
              className="podcasts-btn-secondary"
              target="_blank"
              rel="noopener noreferrer"
            >
              Subscribe
            </Link>
          </div>
        </section>

        {/* ── Podcast list ── */}
        <section ref={sectionRef} className="podcasts-list-section">
          <h2>Latest Podcasts</h2>
          <p className="podcasts-list-sub">Search by title or speaker</p>

          <div className="podcasts-search-wrap">
            <span className="podcasts-search-icon">🔍</span>
            <input
              type="text"
              placeholder="Search podcasts..."
              value={searchTerm}
              onChange={handleSearch}
              className="podcasts-search-bar"
            />
          </div>

          {paginated.length > 0 ? (
            paginated.map((podcast) => (
              <div key={podcast.sys.id} className="podcast-item">
                <Link
                  to={`/podcasts/${generateSlug(podcast.fields.title)}`}
                  className="podcast-thumb-link"
                >
                  <img
                    src={getYoutubeThumbnail(podcast.fields.pageUrl)}
                    alt={podcast.fields.title}
                    className="podcast-thumbnail"
                  />
                </Link>
                <div className="podcast-info">
                  <Link to={`/podcasts/${generateSlug(podcast.fields.title)}`}>
                    <h3 className="podcast-title">{podcast.fields.title}</h3>
                  </Link>
                  <div className="podcast-meta-pills">
                    <span className="podcast-pill">{podcast.fields.speaker}</span>
                    <span className="podcast-pill podcast-pill-date">
                      {podcast.fields.date}
                    </span>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p className="podcasts-empty">No podcasts found.</p>
          )}

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="podcasts-pagination">
              {[...Array(totalPages).keys()].map((n) => (
                <button
                  key={n}
                  onClick={() => setCurrentPage(n + 1)}
                  className={`page-btn ${currentPage === n + 1 ? "active" : ""}`}
                >
                  {n + 1}
                </button>
              ))}
            </div>
          )}
        </section>

      </main>
      <Footer />
    </div>
  );
};

export default withScroll(Podcasts);